import { useMsal } from '@azure/msal-react'
import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../api'
import { UserProfile } from '../types'

export const useUserQuery = () => {
  const { accounts } = useMsal()

  return useQuery<UserProfile>({
    queryKey: ['userData'],
    queryFn: async ({ signal }) => {
      const response = await apiClient.get<UserProfile>('/v3/users/me?workdaySync=true')(signal as AbortSignal)

      return response.data
    },
    enabled: Boolean(accounts.length),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: true,
  })
}
